import { tProvidersProps } from '../../../../../../providers/LayoutProvider/Layout.types';
import { AgendaActionContext } from './AgendaAction.context';
import useAgendaAction from './AgendaAction.hook';

export default function AgendaActionProvider(props: tProvidersProps) {
  const { children } = props;
  const agenda = useAgendaAction();

  return (
    <AgendaActionContext.Provider value={agenda}>
      {children}
    </AgendaActionContext.Provider>
  );
}
